import { useState } from "react";

import { makeGetApiCall, makePostApiCall } from "../../../shared/makeApiCall";

export interface AssignedStatus {
  id: number;
  name: string;
}

export default function ProductProcessStatusAssignedViewModel(
  logout: () => void,
  addSnackbar?: (snackbar: any) => void,
) {
  const [loading, setLoading] = useState(false);

  const [updatedCurrentStatuses, setUpdatedCurrentStatuses] = useState<{
    availableStatuses: AssignedStatus[];
    currentProductStatuses: AssignedStatus[];
  }>({
    availableStatuses: [],
    currentProductStatuses: [],
  });

  const updateProductProcessStatuses = async function (productId: number) {
    setLoading(true);
    const callResult: any = await makePostApiCall(
      `updateProductProcessStatusesAssigned/${productId}`,
      {
        availableStatuses: updatedCurrentStatuses.availableStatuses,
        currentProductStatuses: updatedCurrentStatuses.currentProductStatuses,
      },
    );
    setLoading(false);
    if (callResult.success) {
      setUpdatedCurrentStatuses({
        availableStatuses: callResult.data?.availableStatuses || [],
        currentProductStatuses: callResult.data?.currentProductStatuses || [],
      });

      return callResult;
    } else {
      if (callResult.errorStatus === 401) logout();
      return null;
    }
  };

  const getStatusesForProduct = async function (productId: number) {
    setLoading(true);
    const callResult: any = await makeGetApiCall(
      `productProcessStatusesAssigned/${productId}`,
    );
    setLoading(false);
    if (callResult.success) {
      setUpdatedCurrentStatuses({
        availableStatuses: callResult.data?.availableStatuses || [],
        currentProductStatuses: callResult.data?.currentProductStatuses || [],
      });
      return callResult.data;
    } else {
      if (callResult.errorStatus === 401) logout();
      return null;
    }
  };

  return {
    loading,
    getStatusesForProduct,
    updateProductProcessStatuses,
    setUpdatedCurrentStatuses,
    updatedCurrentStatuses,
  };
}
